// src/utils/getStepRows.ts
import { normalizeTableData } from "./tableNormalizer";

export function getStepRows(
  backend: any,
  fallbackTableData: any[] = [],
): any[] {
  if (!backend) return Array.isArray(fallbackTableData) ? fallbackTableData : [];

  // ✅ Resample shape: plotSample (column-oriented) - for ANY step
  if (backend.plotSample) {
    const { rows } = normalizeTableData(backend.plotSample);
    if (rows?.length) return rows;
  }

  // ✅ Any step: backend.tableData in any shape
  if (backend.tableData != null) {
    const { rows } = normalizeTableData(backend.tableData);
    if (rows?.length) return rows;
    return rows ?? [];
  }

  return Array.isArray(fallbackTableData) ? fallbackTableData : [];
}
